import sendRecordId from './sendRecordId'

window.DatoCmsPlugin.init(plugin => {
  sendRecordId(plugin, document)
})
